import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import {
  ERROR_CODES,
  LOGIN_PAGE_ROUTES,
  VIEW_NAME
} from '../../constants/login-constant';
import { ResetPasswordUserResponse } from '../../models/reset-password-api.interface';
import { ResetPasswordFacadeHelper } from './reset-password.facade-helper';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordSupportHelperFacadeService extends ResetPasswordFacadeHelper {
  constructor() {
    super();
  }

  checkForSQADisplayWifiPortal(response: ResetPasswordUserResponse) {
    return response.hasSQA && this.wifiPortalService.getQueryParamsWFP().isWFP;
  }

  checkForSQAScreenDisplay(
    response: ResetPasswordUserResponse
  ): boolean | undefined {
    return (
      (response.hasSQA && (!response.hasEmail || !response.isEmailValid)) ||
      this.checkForSQADisplayWifiPortal(response)
    );
  }

  checkForAddAddressRouteDisplay(
    response: ResetPasswordUserResponse
  ): boolean | undefined {
    return !response.hasSQA && (!response.hasEmail || !response.isEmailValid);
  }

  checkForEmailViewDisplay(
    response: ResetPasswordUserResponse
  ): boolean | undefined {
    return !response.hasSQA && response.hasEmail && response.isEmailValid;
  }

  checkForErrorCode(errors: { code: string }[]): boolean {
    return (
      errors[0]?.code === ERROR_CODES.ERROR_CODE_111 ||
      errors[0]?.code === ERROR_CODES.ERROR_CODE_222
    );
  }

  redirectToNextView(response: ResetPasswordUserResponse) {
    switch (true) {
      case this.checkForSQAScreenDisplay(response):
        this.checkForSQAScreenDisplayHelper();
        break;
      case this.checkForAddAddressRouteDisplay(response):
        this.checkForAddAddressHelper(response);
        break;
      case this.checkForEmailViewDisplay(response):
        this.sendEmailHelper(response);
        break;
      default:
        break;
    }
  }

  checkForAddAddressHelper(response: ResetPasswordUserResponse) {
    if (this.wifiPortalService.handleWifiPortalNoSecurityQuestion(response)) {
      this.recoverYourAccountFacadeService.getRecoverYourAccountPageContent();
      return;
    }

    this.pingOauthService.getAuthConfigContent().subscribe((oauthResponse) => {
      this.handleOauthResponse(oauthResponse);
    });
  }

  handleOauthResponse(response: OauthAEMConfig) {
    if (response.AWS_ACCOUNT_RECOVERY_FLOW_ENABLED) {
      this.redirectToAddAddress(VIEW_NAME.ADD_ADDRESS_SCREEN);
    } else {
      window.location.href = LOGIN_PAGE_ROUTES.ADD_ADDRESS_ROUTE;
    }
  }

  sendEmailHelper(response: ResetPasswordUserResponse) {
    if (this.wifiPortalService.handleWifiPortalNoSecurityQuestion(response)) {
      this.recoverYourAccountFacadeService.getRecoverYourAccountPageContent();
      return;
    }
    const message = this.checkEmailFacadeService.replaceBffEmail(
      response?.email
    );
    this.checkEmailFacadeService.getContent().checkEmailMessage = message;
    this.recoveryOptionsFacade.sendEmailLink(
      this.checkEmailFacadeService.getContent().checkEmailMessage,
      VIEW_NAME.CHECK_YOUR_EMAIL_SCREEN
    );
  }

  redirectHelper(errorCode: string) {
    if (errorCode === ERROR_CODES.ERROR_CODE_111) {
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.ADDRESS_CONFIRMATION_LOADED,
        true
      );
      this.redirectToAddAddress(VIEW_NAME.ADD_ADDRESS_SCREEN);
      return;
    }

    if (errorCode === ERROR_CODES.ERROR_CODE_222) {
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.RECOVERY_ACCOUNT_LOADED,
        true
      );
      this.nextDisplayViewService.nextDisplayView(
        VIEW_NAME.RECOVER_ACCOUNT_SCREEN
      );
      return;
    }
  }

  checkForRecoveryScreenDisplay(
    profileCustResponse: ResetPasswordUserResponse
  ): boolean | undefined {
    return (
      profileCustResponse.hasSQA &&
      profileCustResponse.isEmailValid &&
      profileCustResponse.hasEmail
    );
  }

  awsAccountRecoveryFlow(authConfig: OauthAEMConfig, errorCode: string) {
    authConfig.AWS_ACCOUNT_RECOVERY_FLOW_ENABLED
      ? this.redirectHelper(errorCode)
      : (window.location.href = LOGIN_PAGE_ROUTES.ADD_ADDRESS_ROUTE);
  }

  redirectToAddAddress(addAddressView: string) {
    this.addAddressFacadeService.getAddAddressPageContent(addAddressView);
    this.addAddressFacadeService.addAddressError$.subscribe((errorResponse) => {
      if (errorResponse) {
        this.getResetPasswordContent().errorMessage = errorResponse;
        this.showHideOverylayMessage(true);
      }
    });
  }
}
